export default __webpack_public_path__ + "static/media/emptycareerpage.ce220076.svg";